export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";
export const SHOW_SNACKBAR = "SHOW_SNACKBAR";

export const INVOICE_CONFIG_REQUEST = "INVOICE_CONFIG_REQUEST";
export const INVOICE_CONFIG_SUCCESS = "INVOICE_CONFIG_SUCCESS";
export const INVOICE_CONFIG_GET_SUCCESS = "INVOICE_CONFIG_GET_SUCCESS";
export const INVOICE_CONFIG_VALIDATION_ERROR = "INVOICE_CONFIG_VALIDATION_ERROR";
export const INVOICE_CONFIG_REDIRECT_TO_LIST = "INVOICE_CONFIG_REDIRECT_TO_LIST";
export const HIDE_INVOICE_CONFIG_FIELD_VALIDATION_ERROR =
  "HIDE_INVOICE_CONFIG_FIELD_VALIDATION_ERROR";
